import React from 'react';

function ExtraSection() {
  return (
    <div className="col-lg-6 col-12 d-lg-flex d-none extra-section flex-column">
      <i className="fab fa-cloudversify"></i>
      <h1 className="brand-name">سامانه گزارش‌گیری دارستان صنعت</h1>
      <hr />
      <p>
        ضمن خیر مقدم به شما کاربران محترم سامانه های مانیتوریگ: جهت فعال سازی حساب کاربری خود لطفا با شماره تلفن
        <a
          href="tel:02166455280"
          className="ltr d-inline-block mx-1"
          style={{ color: '#3498db' }}>
          021-66455280
        </a>
        تماس بگیرید.
      </p>
    </div>
  );
}

export default ExtraSection;
